import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";

import ProductsServices from "../../../services/ProductsServices";
import StoreFormProcess from "./StoreFormProcess2";
import Icon from "@mdi/react";
import { mdiLockOutline, mdiCart } from "@mdi/js";
import UEModal from "../../Layout/UEModal";
import Styles from "./FormsList.scss";
import FormsService from "../../../services/FormsService";

const FormsList = (props) => {
   const productService = new ProductsServices();
   const formService = new FormsService();

   // State variables
   const [listForms, setListForms] = useState([]);
   const [checkState, setCheckState] = useState([]);
   const [showProcess, setShowProcess] = useState(false);
   const [listSelectedForms, setListSelectedForms] = useState([]);
   const [terrAddr, setTerrAddr] = useState("");
   const [demName, setDemName] = useState("");
   const [demEmail, setDemEmail] = useState("");
   const [requestorAddr, setRequestorAddr] = useState("");
   const [requestorName, setRequestorName] = useState("");
   const [requestorRef, setRequestorRef] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState(null);

   // Theme colors
   const backgroundColorTheme = props?.uiTheme === "light" ? "#FFFFFF" : "#454756";
   const baseColorTheme = props?.uiTheme === "light" ? "#454756" : "#FFFFFF";

   // Fetch products when entity changes
   useEffect(() => {
      if (props?.entity?.genre?.slug) {
         getProds(props?.entity?.genre?.slug);
      }
   }, [props.entity]);

   // Initialize checkState based on fetched forms
   useEffect(() => {
      if (listForms && listForms?.sections?.length) {
         const initialCheckState = listForms.sections.flatMap((section) =>
            section.forms.map((form) => ({
               ...form,
               isChecked: false,
            }))
         );
         setCheckState(initialCheckState);
      }
   }, [listForms]);

   // Function to fetch products based on genre slug
   const getProds = async (genreSlug) => {
      try {
         const result = await productService.getFormsPRoducts(genreSlug);

         if (Array.isArray(result.sections[0].forms)) {
            result.sections[0].forms.sort(
               (a, b) => a.price.unit_amount - b.price.unit_amount
            );
         }

         setListForms(result);
      } catch (err) {
         console.error("Error fetching products:", err);
         setError("Failed to load products.");
         Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Impossible de charger les produits.",
            background: "#FFFFFF",
            color: baseColorTheme,
         });
      }
   };

   // Handle checkbox change
   const handleCheckChange = (index) => {
      const updatedCheckState = [...checkState];
      updatedCheckState[index].isChecked = !updatedCheckState[index].isChecked;
      setCheckState(updatedCheckState);

      // Update selected forms
      const selected = updatedCheckState.filter((item) => item.isChecked);
      setListSelectedForms(selected);
   };

   // Handle the process button click
   const handleProcess = () => {
      if (listSelectedForms.length <= 0) {
         Swal.fire({
            title: `<p style="color:${baseColorTheme};">Formulaire</p>`,
            html: `<p style="color:${baseColorTheme};">Merci de sélectionner au moins un type de formulaire avant de valider !</p>`,
            background: backgroundColorTheme,
            width: "19rem",
            backdrop: true,
         });
      } else {
         if (!props?.entity || props?.entity?.genre?.slug !== "collective") {
            // For non‑collective orders, proceed directly without a map capture
            const defaultTerrAddr = "";
            const defaultDemName = props.meName || "Default Name";
            const defaultDemEmail = props.meEmail || "default@example.com";
            const defaultRequestorAddr = props.entity
               ? `${props.entity.address}, ${props.entity.cp} ${props.entity.city}`
               : "";
            const defaultRequestorRef = "";
            const deferredPaymentOption = props.entity
               ? `${props.entity.deferred_payment_option}`
               : "immediate";

            createDocumentOrderSession(
               defaultTerrAddr,
               defaultDemName,
               defaultDemEmail,
               defaultRequestorAddr,
               defaultRequestorRef,
               deferredPaymentOption
            );
         } else {
            // For collective entities, show the additional confirmation modal
            Swal.fire({
               title: `<p style="color:${baseColorTheme};">Formulaire</p>`,
               html: `<div class="d-flex flex-column justify-content-start align-items-start w-100">
                   <div class="font-weight-bold mt-4">Références d'enregistrement</div>
                   <div class="form-group col-12">
                      <label for="terr_addr" class="col-form-label ue-col-form-label">Adresse du bien</label>
                      <input type="text" id="terr_addr" class="form-control ue-form-control" placeholder="Adresse du bien" required>
                   </div>
                   <div class="form-group col-12">
                      <label for="dem_name" class="col-form-label ue-col-form-label">Nom du Demandeur</label>
                      <input type="text" id="dem_name" class="form-control ue-form-control" placeholder="Nom du Demandeur" required>
                   </div>
                   <div class="form-group col-12">
                      <label for="dem_email" class="col-form-label ue-col-form-label">Email du Demandeur</label>
                      <input type="email" id="dem_email" class="form-control ue-form-control" placeholder="Email du Demandeur" required>
                   </div>
                </div>`,
               background: "#FFFFFF",
               width: "598px",
               customClass: {
                  denyButton: "btn btn-lg btn-primary text-white mb-3 btn-block",
                  confirmButton: "btn btn-primary btn-lg text-white btn-block",
                  cancelButton: "btn btn-lg btn-outline-primary btn-block",
                  content: "ueThemeBackground",
               },
               showCancelButton: true,
               showCloseButton: true,
               cancelButtonText: "Annuler",
               confirmButtonText: "Suivant",
               showConfirmButton: true,
               allowOutsideClick: false,
               buttonsStyling: false,
               reverseButtons: false,
               preConfirm: () => {
                  const terr_addr = document.getElementById("terr_addr").value;
                  const dem_name = document.getElementById("dem_name").value;
                  const dem_email = document.getElementById("dem_email").value;

                  if (!terr_addr || !dem_name) {
                     Swal.showValidationMessage("Merci de remplir tous les champs.");
                  }

                  return { terr_addr, dem_name, dem_email };
               },
            }).then((result) => {
               if (result.isConfirmed) {
                  const { terr_addr, dem_name, dem_email } = result.value;
                  setTerrAddr(terr_addr);
                  setDemName(dem_name);
                  setDemEmail(dem_email);
                  setShowProcess(true);
               }
            });
         }
      }
   };

   // Function to create Document Order Session without a captured image
   const createDocumentOrderSession = async (
      terr_addr,
      dem_name,
      dem_email,
      requestor_addr,
      requestor_ref,
      paymentTiming
   ) => {
      setIsLoading(true);
      setError(null);

      // Prepare the products data
      const products = listSelectedForms.map((product) => ({
         id: product.price.id,
         quantity: 1,
         code: product.metadata.prod_lib.toLowerCase(),
         unit_amount: product.price.unit_amount,
      }));

      // Prepare the payload without the captured_image field
      const payload = {
         products: products,
         terr_addr: terr_addr,
         dem_name: dem_name,
         dem_email: dem_email,
         requestor_addr: requestor_addr,
         requestor_ref: requestor_ref,
         commune: props.currentCom,
         parcelle: props.currentParcelle,
         payment_timing: paymentTiming,
      };

      axios
         .post("/Api/checkout/document-orders", payload)
         .then((response) => {
            if (response.data.url) {
               window.location.href = response.data.url;
            } else {
               Swal.fire({
                  icon: "success",
                  title: "Commande enregistrée",
                  html: "Votre demande sera traitée au plus vite.<br />Vous pourrez suivre son évolution dans votre dashboard.",
               });
               setListSelectedForms([]);
               setCheckState((prevState) =>
                  prevState.map((item) => ({ ...item, isChecked: false }))
               );
            }
         })
         .catch((err) => {
            console.error("Error creating Document Order Session:", err);
            setError(err.response?.data?.error || "Une erreur est survenue.");
            Swal.fire({
               icon: "error",
               title: "Erreur",
               text:
                  err.response?.data?.error ||
                  "Impossible de créer la session de paiement.",
               background: "#FFFFFF",
               color: baseColorTheme,
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   // Render forms in each section
   const renderSectionFormsList = (section, index) => {
      return (
         <Fragment key={index}>
            <div>
               {section?.forms?.length
                  ? section.forms.map((form, formIndex) =>
                       renderItemsFormList(form, formIndex)
                    )
                  : null}
            </div>
         </Fragment>
      );
   };

   const mySpinner = () => {
      return (
         <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 24 24"
         >
            <circle cx="4" cy="12" r="3" fill="currentColor">
               <animate
                  id="svgSpinners3DotsBounce0"
                  attributeName="cy"
                  begin="0;svgSpinners3DotsBounce1.end+0.25s"
                  calcMode="spline"
                  dur="0.6s"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                  values="12;6;12"
               />
            </circle>
            <circle cx="12" cy="12" r="3" fill="currentColor">
               <animate
                  attributeName="cy"
                  begin="svgSpinners3DotsBounce0.begin+0.1s"
                  calcMode="spline"
                  dur="0.6s"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                  values="12;6;12"
               />
            </circle>
            <circle cx="20" cy="12" r="3" fill="currentColor">
               <animate
                  id="svgSpinners3DotsBounce1"
                  attributeName="cy"
                  begin="svgSpinners3DotsBounce0.begin+0.2s"
                  calcMode="spline"
                  dur="0.6s"
                  keySplines=".33,.66,.66,1;.33,0,.66,.33"
                  values="12;6;12"
               />
            </circle>
         </svg>
      );
   };

   // Render individual form item
   const renderItemsFormList = (form, index) => {
      let refType = "";
      switch (form?.metadata?.prod_lib.toLowerCase()) {
         case "cua":
         case "cub":
            refType = "certif_urba";
            break;
         case "ru":
            refType = "renseign_urba";
            break;
         default:
            break;
      }

      return (
         <div
            key={index}
            className="d-flex flex-row justify-content-between align-items-center my-2 ue-forms-list-card p-3 mx-1"
            style={{
               backgroundColor: checkState[index]?.isChecked ? "#58d2c3" : null,
            }}
         >
            <div className="d-flex flex-row justify-content-start align-items-center">
               {props?.userAccessLevel?.isLeader ||
               (Array.isArray(props?.userAccessLevel?.user_prefs?.access) &&
                  props?.userAccessLevel?.user_prefs?.access.some(
                     (access) => access.name === refType && access.checked
                  )) ? (
                  <input
                     type="checkbox"
                     name={form.metadata?.prod_lib + index}
                     checked={checkState[index]?.isChecked || false}
                     onChange={() => handleCheckChange(index)}
                  />
               ) : (
                  <div>
                     <Icon path={mdiLockOutline} size={0.8} />
                  </div>
               )}
               <div className="font-weight-bold mx-2 text-uppercase formList-code">
                  {form.metadata?.prod_lib}
               </div>
               <div style={{ fontSize: "11px" }}>{form.name}</div>
            </div>
            <div
               style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "6px",
               }}
            >
               {props?.entity?.genre?.slug === "professionnel" ? (
                  <div>
                     <div>
                        <span className="ue-form-price-tag">
                           {(form.price?.unit_amount / 100).toFixed(2)} €
                        </span>{" "}
                        HT
                     </div>
                  </div>
               ) : form?.metadata?.prod_level === "pro" ? (
                  <div>
                     <div className="ue-form-tag-pro">PRO</div>
                  </div>
               ) : form?.metadata?.prod_level === "demo" ? (
                  <div className="ue-form-tag-demo">DEMO</div>
               ) : (
                  <div className="ue-form-tag-basic">BASIC</div>
               )}
            </div>
         </div>
      );
   };

   const renderFormList = () => {
      const isCollective = props?.entity?.genre?.slug === "collective";
      const totalSum = listSelectedForms
         .reduce(
            (sum, product) =>
               sum + (product.price?.unit_amount ? product.price.unit_amount / 100 : 0),
            0
         )
         .toFixed(2);

      const buttonElement = (
         <div className="text-right" style={{ padding: "8px" }}>
            {props?.dataFormIsReady ? (
               <>
                  <button
                     className="btn btn-primary btn-block my-3 text-white"
                     onClick={handleProcess}
                     style={{ height: "35px", fontWeight: "700" }}
                     disabled={isLoading}
                  >
                     {isLoading ? (
                        <span>{mySpinner()}</span>
                     ) : (
                        <>
                           {isCollective ? (
                              "VALIDER"
                           ) : (
                              <div className="fa-xl">
                                 <Icon
                                    path={mdiCart}
                                    size={1}
                                    className="mr-3"
                                    style={{ verticalAlign: "middle" }}
                                 />
                                 <span className="mr-3">Commander</span> -{" "}
                                 <span className="ml-3">{totalSum} € </span>
                                 <span style={{ fontSize: "0.5em", verticalAlign: "top !important" }}>
                                    HT
                                 </span>
                              </div>
                           )}
                        </>
                     )}
                  </button>
                  <div className="w-100 text-center d-flex justify-content-center align-items-center">
                     <svg
                        width="153"
                        height="42"
                        viewBox="0 0 153 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M36.5443 33.25H5.45562C3.88412 33.25 2.625 32.0512 2.625 30.492V10.6995C2.625 9.13937 3.88412 7.875 5.45562 7.875H36.5434C38.1149 7.875 39.3749 9.13937 39.3749 10.6995V30.492C39.3749 32.0512 38.1149 33.25 36.5443 33.25Z"
                           fill="#03A9F4"
                        />
                        <path
                           d="M32.2412 20.3673C32.3016 19.4039 32.551 18.9559 33.0515 18.9559C33.531 18.9559 33.7935 19.417 33.8267 20.3673H32.2412ZM35.834 20.943C35.834 19.8668 35.5977 19.0154 35.1506 18.4186C34.6781 17.8088 33.9729 17.4999 33.0865 17.4999C31.2595 17.4999 30.115 18.8526 30.115 21.0191C30.115 22.2301 30.4169 23.1428 31.0232 23.7185C31.5631 24.2391 32.3384 24.4999 33.3245 24.4999C34.2406 24.4999 35.0894 24.2803 35.6275 23.9268L35.393 22.4498C34.8619 22.7394 34.2467 22.8969 33.5599 22.8969C33.1486 22.8969 32.8546 22.8068 32.6464 22.6274C32.4171 22.4358 32.2894 22.1269 32.2439 21.6859H35.8034C35.8261 21.5853 35.834 21.0926 35.834 20.943ZM27.175 22.3413C26.9816 22.6711 26.7104 22.8488 26.3962 22.8488C26.1854 22.8488 25.9832 22.8024 25.8109 22.7201V19.4669C26.1854 19.081 26.5231 19.0373 26.6351 19.0373C27.1873 19.0373 27.4585 19.6331 27.4585 20.8021C27.4611 21.4671 27.3605 21.9851 27.175 22.3413ZM28.974 18.1203C28.5907 17.6206 28.0474 17.3739 27.3596 17.3739C26.7366 17.3739 26.1845 17.6381 25.6674 18.1929L25.5431 17.5069H23.6251V27.1249L25.796 26.7609L25.8109 24.3118C26.1495 24.4176 26.4925 24.4736 26.8005 24.4736C27.3491 24.4736 28.1392 24.3363 28.7561 23.6634C29.3397 23.0246 29.6276 22.0341 29.6276 20.7225C29.6276 19.5631 29.4132 18.6838 28.974 18.1203ZM20.5863 17.5069H22.7501V24.4999H20.5863V17.5069ZM21.6861 16.8288C22.3144 16.8288 22.8236 16.309 22.8236 15.6799C22.8236 15.0385 22.3126 14.5249 21.6861 14.5249C21.0404 14.5249 20.5285 15.0385 20.5285 15.6799C20.5285 16.3099 21.0404 16.8288 21.6861 16.8288ZM19.6553 17.4124C19.0384 17.4124 18.5361 17.7379 18.3506 18.3145L18.2194 17.5086H16.3206V24.4999H18.4924V19.9061C18.7654 19.5719 19.1478 19.4511 19.6841 19.4511C19.7953 19.4511 19.9081 19.4511 20.0674 19.4739V17.4666C19.9073 17.4308 19.7751 17.4124 19.6553 17.4124ZM15.4701 19.123L15.7396 17.506H14.3388V15.5416L12.4759 15.8514L12.2055 17.506L11.5501 17.6136L11.3078 19.1239H12.2038V22.2931C12.2038 23.1165 12.412 23.6923 12.8338 24.0414C13.2021 24.3345 13.7184 24.4728 14.4464 24.4728C15.0186 24.4728 15.359 24.3748 15.5813 24.3118V22.5976C15.4649 22.6335 15.1613 22.6983 14.9548 22.6983C14.5348 22.6983 14.3379 22.4795 14.3379 21.9764V19.1195H15.4701V19.123ZM9.21478 20.1686C8.59615 19.9368 8.23653 19.7548 8.23653 19.466C8.23653 19.2254 8.4369 19.0863 8.80178 19.0863C9.44665 19.0863 10.1221 19.3321 10.5719 19.5623L10.8344 17.9619C10.4686 17.7851 9.72403 17.4999 8.69765 17.4999C7.96265 17.4999 7.35453 17.6924 6.93541 18.0433C6.46991 18.4186 6.23366 18.9559 6.23366 19.606C6.23366 20.7846 6.95465 21.2843 8.1289 21.7078C8.87878 21.9773 9.13865 22.1689 9.13865 22.4673C9.13865 22.749 8.8989 22.917 8.44303 22.917C7.89703 22.917 7.00715 22.6458 6.40691 22.3019L6.16016 23.9233C6.66416 24.205 7.59165 24.4999 8.56465 24.4999C9.34078 24.4999 9.9839 24.3161 10.4039 23.9696C10.9009 23.5916 11.1424 23.0273 11.1424 22.3028C11.1441 21.0926 10.4048 20.5895 9.21478 20.1686Z"
                           fill="white"
                        />
                        <path d="M150.562 28.4375C150.562 30.2323 149.107 31.6875 147.312 31.6875H119.688C117.893 31.6875 116.438 30.2323 116.438 28.4375V10.5625C116.438 8.76769 117.893 7.3125 119.688 7.3125H147.312C149.107 7.3125 150.562 8.76769 150.562 10.5625V28.4375Z" fill="#3F51B5" />
                        <path d="M138.375 11.375C136.22 11.375 134.153 12.231 132.63 13.7548C131.106 15.2785 130.25 17.3451 130.25 19.5C130.25 21.6549 131.106 23.7215 132.63 25.2452C134.153 26.769 136.22 27.625 138.375 27.625C140.53 27.625 142.597 26.769 144.12 25.2452C145.644 23.7215 146.5 21.6549 146.5 19.5C146.5 17.3451 145.644 15.2785 144.12 13.7548C142.597 12.231 140.53 11.375 138.375 11.375Z" fill="#FFC107" />
                        <path d="M131.886 24.375C131.509 23.8737 131.185 23.3317 130.931 22.75H135.257C135.483 22.2332 135.66 21.6905 135.775 21.125H130.414C130.307 20.6001 130.25 20.0574 130.25 19.5H135.938C135.938 18.9426 135.881 18.3999 135.774 17.875H130.413C130.529 17.3095 130.705 16.7667 130.931 16.25H135.257C135.003 15.6683 134.68 15.1263 134.302 14.625H131.886C132.241 14.1537 132.642 13.7134 133.09 13.3291C131.669 12.1136 129.828 11.375 127.812 11.375C123.325 11.375 119.688 15.0126 119.688 19.5C119.688 23.9874 123.325 27.625 127.812 27.625C130.469 27.625 132.819 26.3453 134.301 24.375H131.886Z" fill="#FF3D00" />
                        <path d="M93.5625 28.4375C93.5625 30.2323 92.1073 31.6875 90.3125 31.6875H62.6875C60.8927 31.6875 59.4375 30.2323 59.4375 28.4375V10.5625C59.4375 8.76769 60.8927 7.3125 62.6875 7.3125H90.3125C92.1073 7.3125 93.5625 8.76769 93.5625 10.5625V28.4375Z" fill="#1565C0" />
                        <path d="M69.3388 15.4373L67.2052 21.8008C67.2052 21.8008 66.6632 19.109 66.6096 18.771C65.3949 15.9996 63.6025 16.154 63.6025 16.154L65.715 24.3748V24.3732H68.2834L71.8348 15.4373H69.3388ZM71.3725 24.3748H73.7052L75.1157 15.4373H72.7537L71.3725 24.3748ZM87.8817 15.4373H85.4271L81.6002 24.3748H83.9175L84.3952 23.0984H87.317L87.5656 24.3748H89.6887L87.8817 15.4373ZM85.042 21.3913L86.3119 18.0138L86.9765 21.3913H85.042ZM78.425 18.0422C78.425 17.5498 78.8296 17.1834 79.9898 17.1834C80.7438 17.1834 81.6075 17.731 81.6075 17.731L81.9862 15.855C81.9862 15.855 80.8828 15.4365 79.7997 15.4365C77.3468 15.4365 76.0817 16.6098 76.0817 18.095C76.0817 20.7811 79.3147 20.4131 79.3147 21.7927C79.3147 22.0291 79.127 22.576 77.7807 22.576C76.4303 22.576 75.539 22.0811 75.539 22.0811L75.1368 23.8816C75.1368 23.8816 76.0005 24.374 77.6694 24.374C79.3423 24.374 81.6628 23.1228 81.6628 21.3255C81.6628 19.1635 78.425 19.0075 78.425 18.0422Z" fill="white" />
                     </svg>
                     <div
                        className="ml-3 text-center d-flex justify-content-center align-items-center"
                        style={{ height: "42px", display: "flex", alignItems: "center", verticalAlign: "middle" }}
                     >
                        Paiement sécurisé par Stripe
                     </div>
                  </div>
               </>
            ) : (
               <div className="btn btn-primary btn-block my-3 text-white" style={{ height: "35px" }}>
                  {mySpinner()}
               </div>
            )}
         </div>
      );

      if (!isCollective) {
         return (
            <div>
               {buttonElement}
               <div className="ue-data-forms-list">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                     <h5 style={{ fontWeight: "700", padding: "8px", marginLeft: "40px" }}>
                        Sélectionnez votre formulaire
                     </h5>
                     <div
                        className="mr-2 p-2 btn btn-outline-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => window.open("https://www.urba-earth.com/pro-forms", "_blank")}
                     >
                        Plus d'info
                     </div>
                  </div>
                  <div className="card ueThemeCard border-0">
                     <div className="cardBody" style={{ padding: "0 5px" }}>
                        {listForms?.sections?.length
                           ? listForms.sections.map((section, index) =>
                                renderSectionFormsList(section, index)
                             )
                           : null}
                     </div>
                  </div>
               </div>
            </div>
         );
      } else {
         return (
            <div>
               <div className="ue-data-forms-list">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                     <h5 style={{ fontWeight: "700", padding: "8px", marginLeft: "40px" }}>
                        Sélectionnez votre formulaire
                     </h5>
                  </div>
                  <div className="card ueThemeCard border-0">
                     <div className="cardBody" style={{ padding: "0 5px" }}>
                        {listForms?.sections?.length
                           ? listForms.sections.map((section, index) =>
                                renderSectionFormsList(section, index)
                             )
                           : null}
                     </div>
                  </div>
               </div>
               {buttonElement}
            </div>
         );
      }
   };

   return (
      <>
         <div className="d-flex flex-column align-content-around">{renderFormList()}</div>
         <UEModal show={showProcess} onClose={() => setShowProcess(false)} size="lg">
            <StoreFormProcess
               forms={listSelectedForms}
               terrAddr={terrAddr}
               demName={demName}
               demEmail={demEmail}
               requestorAddr={requestorAddr}
               requestorName={requestorName}
               requestorRef={requestorRef}
               onClose={() => setShowProcess(false)}
            />
         </UEModal>
      </>
   );
};

const mapStateToProps = (state) => {
   return {
      entity: state.MeReducer.entity,
      meName: state.MeReducer.name,
      meEmail: state.MeReducer.email,
      subscription: state.MeReducer.subscription,
      uiTheme: state.AppReducer.ui_theme,
      dataFormIsReady: state.FormsReducer.dataFormIsReady,
      userAccessLevel: state.MeReducer.access_level,
      currentCom: state.MapReducer.currentCom,
      currentParcelle: state.MapReducer.currentParcelle,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      showDataPanel: (e) =>
         dispatch({ type: "SHOW_FLOATING_DATA_PANEL", data: e }),
      showDetailData: (e) =>
         dispatch({ type: "SHOW_DETAIL_PANEL_DATA", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(FormsList);
